import React, {useCallback, useEffect, useMemo, useState} from 'react'
import PropTypes from 'prop-types'
import {TextInput, TextArea} from "../../field/text-inputs";
import {useTranslation} from "react-i18next";
import {FlexGrid} from "../../../grid";
import {random} from "../../../../helper";
import {Image} from "../../field/image";
import {BiCommentAdd} from "react-icons/bi";
import * as R from "ramda";
import Api from "../../../../service/api";
import {useToasts} from "react-toast-notifications";
import {FiEdit, FiRefreshCw, FiTrash2} from "react-icons/fi";
import {OverlayLoader} from "../../../loader";
import styled from "styled-components";
import {ButtonSecondary, ButtonWithAccordion} from "../../../button";
import {IconComments, IconPlus, IconTrash, IconUpdate} from "../../../icons";
import {ModalConfirmDelete} from "../../../modals";

const CommentsBoxWrapper = styled.div`
    margin: 30px 0 25px 0;
`

const CommentsBox = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    width: 100%;
    gap: 14px;
    
    //TODO: check the media point transition
    @media all and (max-width: 1600px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media all and (max-width: 1200px) {
      grid-template-columns: repeat(1, 1fr);
    }
`

const CommentBox = styled.div`
    display: flex;
    //width: 557px;
    padding: 16px 16px 0 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
  
    border: 1px solid var(--it-stroke-grey);
    background: var(--it-bg-cards, rgba(238, 238, 238, 0.03));
`

const CommentsBtnsCont = styled.div`
  margin-top: 24px;
  display: flex;
  gap: 12px;
  width: 100%;
`

const HeaderBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const HeaderTitle = styled.div`
    color: var(--it-text-white);
    
    /* H4 */
    font-family: "Druk Wide";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%; /* 16.8px */
    letter-spacing: 0.42px;
    text-transform: uppercase;
`

const HeaderButtonsCont = styled.div`
  display: flex;
  gap: 10px;
`

export const Comment = ({
                            id,
                            onChange,
                            onRemove,
                            onRefresh,
                            avatar,
                            fio,
                            comment,
                            answer,
                            rating,
                            likes,
                             ...rest
                         }) => {
    const { t } = useTranslation();
    const [deleteModal, updateDeleteModal] = useState({isShow: false, itemId: false});

    const openModalConfirmDelete = () => updateDeleteModal((prevState) => ({ ...prevState, isShow: true}))
    const closeModalConfirmDelete = () => updateDeleteModal((prevState) => ({ ...prevState, isShow: false}))

    const onRemoveBtnClick = (event) => {
      event.preventDefault()
      openModalConfirmDelete()
    }

  const doRemove = (event) => {
    event.preventDefault()
    onRemove && onRemove(id)
    closeModalConfirmDelete()
  }

    const onChangeField = useCallback((e)=>{
        typeof onChange === 'function' && onChange(id, e.currentTarget.name, e.currentTarget.value)
    }, [onChange]);
    const onChangeAvatar = useCallback((img)=>{
        typeof onChange === 'function' && onChange(id, 'avatar', img)
    }, [onChange]);

    rating = useMemo(()=>{
        return rating || random(4,5);
    }, [rating])
    likes = useMemo(()=>{
        return likes || random(50,200);
    }, [likes])

    useEffect(() => {
        if(typeof onChange === 'function'){
            onChange(id, 'rating', rating);
            onChange(id, 'likes', likes);
        }
    }, []);

    let color = 'blue';
    return (
      <CommentBox>
        <HeaderBox>
          <HeaderTitle>{t(`form.field.comment.generated_comment`)}</HeaderTitle>

          <HeaderButtonsCont>
            <ButtonSecondary data-transparent
                             onClick={() => onRefresh(id)}
                             type={"button"}
            >
              <IconUpdate size={16}/>
            </ButtonSecondary>

            <ButtonSecondary data-transparent
                             onClick={onRemoveBtnClick}
                             type={"button"}
            >
              <IconTrash size={16}/>
            </ButtonSecondary>

            <ModalConfirmDelete
              isOpen={deleteModal.isShow}
              itemIds={deleteModal.itemId}
              onCancel={closeModalConfirmDelete}
              onConfirm={doRemove}
              description={t('modal.confirmdelete.description_comment')}
            />
          </HeaderButtonsCont>
        </HeaderBox>
        <>
          <FlexGrid
            /*className={'w-full px-4 py-4 rounded'}*/
            className={'w-full'}
            columns={[{
              // className: `py-2 px-2`,
              content: <Image css={{w: 40, h: 40}}
                              name={'avatar'}
                              defaultValue={avatar}
                              onDrop={onChangeAvatar}
                              onRemove={() => onChangeAvatar(null)}
                              className={""}
                              dropMessage={t(`form.field.comment.avatar_drop_message`)}/>,
            }, {
              className: `py-2 px-2`,
              flex: 1,
              content: <>
                <TextInput
                  className={"w-full"}
                  name={"fio"}
                  defaultValue={fio}
                  label={t(`form.field.comment.fio`)}
                  errorMessage={''}
                  onChange={onChangeField}
                />

                <TextArea
                  className={"w-full"}
                  name={"comment"}
                  defaultValue={comment}
                  rows={4}
                  label={t(`form.field.comment.comment`)}
                  errorMessage={''}
                  onChange={onChangeField}
                />

                <TextArea
                  className={"w-full"}
                  name={"answer"}
                  defaultValue={answer}
                  rows={4}
                  label={t(`form.field.comment.answer`)}
                  errorMessage={''}
                  onChange={onChangeField}
                />

                <FlexGrid columns={[{
                  className: ``,
                  flex: 1,
                  content: <>
                    <TextInput
                      name={"rating"}
                      defaultValue={rating}
                      label={t(`form.field.comment.rating`)}
                      errorMessage={''}
                      onChange={onChangeField}/>
                  </>,
                }, {
                  className: `pl-2`,
                  flex: 1,
                  content: <>
                    <TextInput
                      name={"likes"}
                      defaultValue={likes}
                      label={t(`form.field.comment.likes`)}
                      errorMessage={''}
                      onChange={onChangeField}/>
                  </>,
                },]}/>
              </>,
            }]}
          />
        </>
      </CommentBox>
    );
}


export const Comments = ({
                           className = '',
                           inputRef = false,
                           inline = false,
                           label = '',
                           labelBold = false,
                           name = '',
                           defaultValue = [],
                           lang,
                           category,
                           onChange,
                           ...rest
                         }) => {
  const {t} = useTranslation();
  const {addToast} = useToasts()
  const [isLoadingGeneration, setLoadingGeneration] = useState(false)
  const [commentsCount, setCommentsCount] = useState(5)
  const [comments, setComments] = useState(defaultValue || [])

  const onGenerateComments = useCallback(() => {
    setLoadingGeneration(true);
    Api.commentsGenerate(category, lang, commentsCount)
      .then((newComments) => {
        setLoadingGeneration(false);

        if (!newComments || newComments.length == 0) {
          addToast(t(`form.field.comment.generate_nodata`), {
            appearance: 'info',
            autoDismiss: true,
          })
          return;
        }
        newComments = newComments.map((comment, idx) => {
          comment.id = Date.now() + `_${idx}`;
          comment.time = Date.now();
          return comment;
        })

        setComments([...comments, ...newComments])

        addToast(t(`form.field.comment.generate_success`, {count: newComments.length}), {
          appearance: 'success',
          autoDismiss: true,
        })
      })
      .catch((error) => {
        setLoadingGeneration(false);
        console.error('new commments', error);
        addToast(t(`form.field.comment.generate_error`), {
          appearance: 'error',
          autoDismiss: true,
        })
      })
  }, [category, lang, comments])
  const onAddComment = useCallback(() => {
    setComments([...comments, {id: Date.now(), time: Date.now()}])
  }, [comments])
  const onRemoveComment = useCallback((commentId) => {
    const idx = R.findIndex(R.propEq('id', commentId))(comments)
    if (idx < 0) return;
    comments.splice(idx, 1);
    let newComments = [...comments];
    setComments(newComments)
    typeof onChange === 'function' && onChange(newComments);
  }, [comments])
  const onRefreshComment = useCallback((commentId) => {
    const idx = R.findIndex(R.propEq('id', commentId))(comments)
    if (idx < 0) return;

    setLoadingGeneration(true);
    Api.commentsGenerate(category, lang, 1)
      .then((newComments) => {
        setLoadingGeneration(false);

        if (!newComments || newComments.length == 0) {
          addToast(t(`form.field.comment.generate_nodata`), {
            appearance: 'info',
            autoDismiss: true,
          })
          return;
        }


        newComments[0].id = comments[idx].id;
        newComments[0].time = Date.now();
        comments[idx] = newComments[0];

        setComments([...comments])

        addToast(t(`form.field.comment.generate_success`, {count: newComments.length}), {
          appearance: 'success',
          autoDismiss: true,
        })
      })
      .catch((error) => {
        setLoadingGeneration(false);
        console.error('refresh commment', error);
        addToast(t(`form.field.comment.generate_error`), {
          appearance: 'error',
          autoDismiss: true,
        })
            })
    }, [lang, category, comments])

    const onCommentChange = useCallback((commentId, fieldName, value)=>{
        let commentIdx = R.findIndex(R.propEq('id', commentId))(comments)
        if(commentIdx < 0) return;
        comments[commentIdx][fieldName] = value;
        let newComments = [...comments];
        setComments(newComments);
        typeof onChange === 'function' && onChange(newComments);
    }, [comments])

    // useEffect(()=>{
    //
    // }, [comments])

    let color = 'blue';

    return (
      <CommentsBoxWrapper>
        <ButtonWithAccordion
          btnIcon={<IconComments size={20}/>}
          btnTitle={t(`form.field.comment.title`)}
          isOpenInit={false}
        >
          <OverlayLoader show={isLoadingGeneration} style={{width: '100%'}}>
            <>
              {/*TODO: check the label necessary? */}
              {/*<div className={`form-label ${labelBold ? 'font-bold' : ''}`}>{label || t(`form.field.comment.title`)}</div>*/}

              <CommentsBox>
                {comments && comments.map((comment, idx, allComments) => {
                  return <Comment key={`${comment.id}_${comment.time}`}
                                  {...comment}
                                  onRefresh={onRefreshComment}
                                  onChange={onCommentChange}
                                  onRemove={onRemoveComment}
                  />
                })}
              </CommentsBox>

              <CommentsBtnsCont>
                <ButtonSecondary onClick={onGenerateComments}
                                 type={"button"}
                >
                  <IconComments size={20}/>
                  {t(`form.field.comment.btn_generate`, {count: commentsCount, category})}
                </ButtonSecondary>

                <ButtonSecondary onClick={onAddComment}
                                 type={"button"}
                >
                  <IconPlus size={20}/>
                  {t(`form.field.comment.btn_addcomment`)}
                </ButtonSecondary>
              </CommentsBtnsCont>
            </>
          </OverlayLoader>
        </ButtonWithAccordion>
      </CommentsBoxWrapper>
    )

    // return (
    //     <div className={type.toLocaleLowerCase() === 'hidden' ? 'hidden' : `form-element flex-auto ${inline ? 'form-element-inline' : ''} ${className}`}>
    //         {label && <div className="form-label">{label}</div>}
    //         <input
    //             {...rest}
    //             {...(inputRef ? {ref: inputRef} : {})}
    //             name={name}
    //             type={type}
    //             className={`form-input ${
    //                 // errorMessage ? 'border-red-500' : ''
    //                 errorMessage ? ' form-input-invalid' : ''
    //                 + validMessage ? ' form-input-valid' : ''
    //             }`}
    //             placeholder={placeholder}
    //         />
    //         {errorMessage && (
    //             <div className="form-error">{errorMessage}</div>
    //         )}
    //         {validMessage && (
    //             <div className="form-success">{validMessage}</div>
    //         )}
    //         {hint && (<div className="form-hint" dangerouslySetInnerHTML={{__html: hint}}/>)}
    //     </div>
    // )
}
Comments.propTypes = {
    inline: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    hint: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    errorMessage: PropTypes.string,
    validMessage: PropTypes.string
}
